<script>
export default {
  inheritAttrs: false,
  props: {
    startTime: {
      type: String,
      default: ''
    },
    time: {
      type: Number,
      default: 0
    },
    notify: {
      type: Boolean,
      default: true
    },
    reserveFlg: Boolean
  },
  data() {
    return {
      timeData: {}
    };
  },
  methods: {
    renderBlock(data /*, props = {} */) {
      // const { days, hours, minutes, seconds } = props;
      // if ([days, hours, minutes, seconds].every((t) => t === 0)) {
      // location.reload();
      // return;
      // }
      let str = new String(data);
      str.length === 1 && (str = `0${str}`);
      return [<div class="block">{str[0]}</div>, <div class="block">{str[1]}</div>];
    },
    reserve() {
      this.$emit('reserve');
    }
  },
  render() {
    const props = {
      style: { width: '100%' },
      props: {
        ...this.$attrs,
        time: this.time
      },
      scopedSlots: {
        default: (props) => {
          return (
            <div class="slot-wrap">
              <div class="block-wrap">
                <div class="block-content">
                  {this.renderBlock(props.days, props)}
                  <div class="colon">:</div>
                </div>
                <div class="block-tip-text">天</div>
              </div>
              <div class="block-wrap">
                <div class="block-content">
                  {this.renderBlock(props.hours, props)}
                  <div class="colon">:</div>
                </div>
                <div class="block-tip-text">小时</div>
              </div>
              <div class="block-wrap">
                <div class="block-content">
                  {this.renderBlock(props.minutes, props)}
                  <div class="colon">:</div>
                </div>
                <div class="block-tip-text">分</div>
              </div>
              <div class="block-wrap">
                <div class="block-content">{this.renderBlock(props.seconds, props)}</div>
                <div class="block-tip-text">秒</div>
              </div>
            </div>
          );
        }
      },
      on: {
        ...this.$listeners
      }
    };
    return this.time ? (
      <div ref="test" class="count-down-big-wrap">
        {<div class="title">距离{this.startTime}直播开始还有</div>}
        <van-count-down {...props}></van-count-down>
        {this.notify ? (
          <div class={{ reserved: this.reserveFlg, action: true }} onclick={this.reserve}>
            {this.reserveFlg ? '已预约' : '直播预约'}
          </div>
        ) : null}
      </div>
    ) : null;
  }
};
</script>
